import { apiFetch } from '../fetch';
import { Currency } from './interfaces';

export const getCurrencies = (): Promise<Currency[]> => apiFetch<Currency[]>('/PageOptions/Currencies');
